// extracted by mini-css-extract-plugin
export var dot = "_r5-2";
export var wave = "_r5-0";
export var waveSmall = "_r5-1";